import * as React from 'react';
import { Grid } from 'react-flexbox-grid';
import { compose, withState, withHandlers, withProps } from 'recompose';
import { Divider, Card } from 'material-ui';
import { withRouter } from 'react-router';

import UniversalFilter from '@inqool/uas-web-core/es/components/controls/UniversalFilter';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { get, safePut } from '@inqool/uas-web-core/es/utils/storage';
import { getGlobalSearch } from './_globalSearchActions';
import { globalSearchAgendas } from './_globalSearchEnums';
import { filterByModulesAndPermissions } from '@utils/utils';

let breakPromiseLoop;

const enhance = compose<any, any>(
  withRouter,
  withState('globalSearch', 'handleGlobalSearch', ''),
  withState('searchedValue', 'handleSearchedValue', ''),
  withState('results', 'handleResults', []),
  withState('searchedAgendasCount', 'handleSearchedAgendasCount', 0),
  withState('disabledSearch', 'handleDisabledSearch', false),
  withProps(({ modules }) => {
    return {
      filteredGlobalSearchAgendas: filterByModulesAndPermissions(modules, globalSearchAgendas)
    };
  }),
  withHandlers({
    closeItem: ({ closeItem }) => () => {
      breakPromiseLoop = true;
      closeItem();
    },
    handleSubmit: ({
      globalSearch,
      searchedValue,
      handleSearchedValue,
      handleResults,
      handleSearchedAgendasCount,
      handleDisabledSearch,
      filteredGlobalSearchAgendas
    }) => async () => {
      if (globalSearch !== searchedValue) {
        handleSearchedValue(globalSearch);
        handleDisabledSearch(true);
        handleResults([]);
        let newResults: Array<any> = [];
        let count = 0;
        breakPromiseLoop = false;
        for (const agenda of filteredGlobalSearchAgendas) {
          const agendaResult = await getGlobalSearch({ globalSearch, ...agenda });

          if (breakPromiseLoop) {
            break;
          }

          newResults = [...newResults, agendaResult];
          ++count;
          handleSearchedAgendasCount(count);
          handleResults(newResults);
        }
        handleDisabledSearch(false);
      }
    }
  })
);

const AgendaSearchDetail = ({ history, label, count, path, gridName, globalSearch, closeItem }) => {
  const onClick = () => {
    if (gridName) {
      safePut(gridName, { ...JSON.parse(get(gridName)), universalFilter: globalSearch });
    }
    history.push({ pathname: path, state: { universalFilter: globalSearch } });
    closeItem();
  };

  return (
    <Card style={{ margin: '10px' }}>
      <div className="global-search-header" style={{ backgroundColor: '#39579e', color: 'white', width: '100%' }}>
        <div style={{ padding: '10px' }}>{label}</div>
      </div>
      <div
        className="global-search-body"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <div style={{ margin: '10px' }}>
          Počet nalezených výsledků v agendě <span style={{ color: '#39579e' }}>{label}</span>: {count}
        </div>
        <Button label={'Zobrazit Detail'} onClick={onClick} style={{ margin: '10px' }} />
      </div>
    </Card>
  );
};

const View = ({
  history,
  closeItem,
  handleGlobalSearch,
  results,
  handleSubmit,
  searchedAgendasCount,
  disabledSearch,
  filteredGlobalSearchAgendas
}) => (
  <div style={{ height: '60vh' }}>
    <div style={{ height: '10vh', display: 'flex', alignItems: 'center' }}>
      <UniversalFilter
        style={{ marginLeft: '10px', padding: 0, width: '100%', bottom: 0 }}
        onChange={handleGlobalSearch}
        inputProps={{ disabled: disabledSearch }}
      />
      <div>
        {searchedAgendasCount}/{filteredGlobalSearchAgendas.length}
      </div>
      <Button label={'Vyhledat'} onClick={handleSubmit} style={{ margin: '10px' }} disabled={disabledSearch} />
    </div>
    <Divider />
    <div style={{ height: '40vh', overflow: 'auto' }}>
      <Grid fluid={true} style={{ padding: 0 }}>
        {results.map(
          agendaResult =>
            agendaResult && (
              <AgendaSearchDetail key={agendaResult.path} closeItem={closeItem} history={history} {...agendaResult} />
            )
        )}
      </Grid>
    </div>
    <Divider />
    <div style={{ height: '10vh' }}>
      <Button label={'Zavřít'} onClick={closeItem} style={{ margin: '10px' }} />
    </div>
  </div>
);

export const GlobalSearchModal = enhance(View);



// WEBPACK FOOTER //
// ./src/components/sidebar/globalSearch/GlobalSearchModal.tsx